import React from "react";
import { setTitle } from "../helpers/MetaTag";
import { Outlet } from "react-router-dom";

const NoLayout = ({ metaTitle = "" }) => {
  setTitle(`Game Time HR | ${metaTitle}`);

  return (
    <>
      <Outlet />
    </>
  );
};

export default NoLayout;
